import update from 'immutability-helper';
// import { REQUEST } from '../actions/action_types';
import * as EXPERIENCE from '../actionTypes/experiences';
import { LAYOUT } from '../constants/experiences';

const initState = {
  areaID: '',
  layouts: [],
  [LAYOUT.E_PRODUCT_BANNER.NAME]: {
    data: [],
    dataNext: false,
    layoutID: ''
  },
  [LAYOUT.E_PRODUCT_FEATURE.NAME]: {
    data: [],
    dataNext: false,
    layoutID: ''
  },
  [LAYOUT.E_PRODUCT_LIST.NAME]: {
    data: [],
    dataNext: false,
    layoutID: ''
  },
  [LAYOUT.E_AGENT_PRODUCT.NAME]: {
    data: [],
    dataNext: false,
    layoutID: ''
  }
};
const copyState = JSON.parse(JSON.stringify(initState));

export default (state = copyState, action) => {
  switch (action.type) {
    case EXPERIENCE.GET_EXPERIENCE_ID.LOADING:
      return {
        ...state,
        areaID: '',
        layouts: []
      };

    case EXPERIENCE.GET_EXPERIENCE_ID.SUCCESS:
      return {
        ...state,
        areaID: action.payload.areaID,
        layouts: action.payload.data
      };

    case EXPERIENCE.GET_EXPERIENCE_ID.FAIL:
      return {
        ...state,
        areaID: '',
        layouts: []
      };

    case EXPERIENCE.GET_E_PRODUCT_BANNER.LOADING:
    case EXPERIENCE.GET_E_PRODUCT_LIST.LOADING:
    case EXPERIENCE.GET_E_PRODUCT_FEATURE.LOADING:
    case EXPERIENCE.GET_E_AGENT_PRODUCT.LOADING:
      return {
        ...state,
        [action.payload.key]: {
          ...state[action.payload.key]
        }
      };
    case EXPERIENCE.GET_E_PRODUCT_BANNER.SUCCESS:
    case EXPERIENCE.GET_E_PRODUCT_LIST.SUCCESS:
    case EXPERIENCE.GET_E_PRODUCT_FEATURE.SUCCESS:
    case EXPERIENCE.GET_E_AGENT_PRODUCT.SUCCESS:
      return {
        ...state,
        layouts: updateObjectKeyOfID(state, action),
        [action.payload.key]: {
          data: action.payload.data,
          dataNext: action.payload.dataNext,
          layoutID: action.payload.layoutID
        }
      };

    case EXPERIENCE.GET_E_PRODUCT_LIST.NEXT_SUCCESS:
      return {
        ...state,
        layouts: updateObjectKeyOfID(state, action),
        [action.payload.key]: {
          ...state[action.payload.key],
          data: state[action.payload.key].data.concat(action.payload.data),
          dataNext: action.payload.dataNext
        }
      };

    case EXPERIENCE.GET_E_PRODUCT_BANNER.FAIL:
    case EXPERIENCE.GET_E_PRODUCT_LIST.FAIL:
    case EXPERIENCE.GET_E_PRODUCT_FEATURE.FAIL:
    case EXPERIENCE.GET_E_AGENT_PRODUCT.FAIL:
      return {
        ...state,
        [action.payload.key]: {
          data: [],
          dataNext: false,
          layoutID: ''
        }
      };

    case EXPERIENCE.GET_E_PRODUCT_LIST.SET_LIKE:
      return setLayoutDataLike(state, action.payload);

    case EXPERIENCE.INIT_EXPERIENCES:
      return initState;

    default:
      return state;
  }
};

const setLayoutDataLike = (state, payload) => {
  const { key, isLike, index } = payload;
  const newState = update(state, {
    [key]: {
      data: {
        [index]: {
          is_like: { $set: isLike }
        }
      }
    }
  });
  return newState;
};

/** updateObjectKeyOfID
 * @description 每次取得該 layout 資料後要一併更新 layouts 內的 layout dataNextToken 已達成下筆取該 layout 區塊資料時能隨機不重複資料目的
 */
const updateObjectKeyOfID = (state, action) => {
  const data = state.layouts;
  const { dataNextToken, layoutID } = action.payload;

  return data.map(item => ({
    id: item.id,
    name: item.name,
    dataNextToken: item.id === layoutID ? dataNextToken : item.dataNextToken,
    category: item.category,
    ad: item.ad || null
  }));
};
